import { UPDATE_DATA, actionHandler } from './updateData'
import {
  QUERIES_LIST_FETCHED,
  queriesActionHandler,
  OPEN_RECORD,
  OPEN_RECORD_START,
  RETURN_INITIAL_STATE,
  matchDocs
} from './queriesFormData'
import { page as pageIndex } from '../../globals'
// ------------------------------------
// Constants
// ------------------------------------
export const UPDATE_CURRENT_LEGIS_DATA = 'UPDATE_CURRENT_LEGIS_DATA'
export const actions = {
  updateCurrentLegisData
}

export function updateCurrentLegisData (location, valueType, valueID, fieldValue) {
  return {
    type: UPDATE_CURRENT_LEGIS_DATA,
    location,
    valueType,
    payload: {
      value: valueID,
      fieldValue: fieldValue,
    }
  }
}
// ------------------------------------
// Actions
// ------------------------------------
function matchRecordInfo (data) {
  return {
    textValues: {
      state: data.state,
      billType: data.billType,
      billNumber: data.billNumber,
      session: data.session,
      companion: data.companion,
      url: data.url,
      version: data.version,
      highlight: data.highlight,
      legisId: data.legisID,
      fileId: data.legisID
    }
  }
}
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA] : (state, action) => action.location.page !== pageIndex.currentLegislation
    ? state : actionHandler(state, action),
  [QUERIES_LIST_FETCHED] : (state, action) => action.payload.page !== pageIndex.currentLegislation
    ? state : queriesActionHandler(state, action),
  [OPEN_RECORD_START] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [OPEN_RECORD] : (state, action) => {
    const { json, recordIndex, page } = action.payload
    if (page !== pageIndex.currentLegislation) {
      return {
        ...state
      }
    }
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        queryRecords: json,
        currentRecord: json[recordIndex],
        recordIndex: recordIndex
      },
      formDataValue: {
        ...state.formDataValue,
        [page]: {
          ...state.formDataValue[page],
          recordInfo: matchRecordInfo(json[recordIndex].recordInfo),
          otherDocs: matchDocs(json[recordIndex].otherDocs, state.formDataValue[page]),
          navigation: {
            textValues: {
              currentRecord: recordIndex + 1
            }
          },
          settingsLine: {
            textValues: {
              currentLegYear: '2019',
              fileId: json[recordIndex].recordInfo.legisID,
              legisId: json[recordIndex].recordInfo.legisID
            },
            radio: {
              carryOver: ''
            }
          },
          recordSummary: json[recordIndex].recordSummary,
          clientActions: json[recordIndex].clientActions
        }
      }
    }
  },
  [RETURN_INITIAL_STATE] : (state, action) => {
    const { page } = action.payload
    if (page !== pageIndex.currentLegislation) {
      return {
        ...state
      }
    }
    return {
      ...initialState,
      formDataValue: {
        ...initialState.formDataValue,
        [page]: {
          ...initialState.formDataValue[page],
          queryLine: {
            radio: {
              query: state.formDataValue[page].queryLine.radio.query
            }
          },
          queriesList: state.formDataValue[page].queriesList,
          navigation: {
            textValues: {
              currentRecord: state.formDataValue[page].navigation.textValues.currentRecord
            }
          },
          otherDocs: {
            ...initialState.formDataValue[page].otherDocs
          }
        }
      }
    }
  },
  [UPDATE_CURRENT_LEGIS_DATA] : (state, action) => {
    switch (action.valueType) {
      case 'select' : {
        const { id, field } = action.location
        const { value, fieldValue } = action.payload
        return {
          ...state,
          formDataValue: {
            CL: {
              ...state.formDataValue.CL,
              [field]: {
                ...state.formDataValue.CL[field],
                [id]: {
                  ...state.formDataValue.CL[field][id],
                  radio: {
                    ...state.formDataValue.CL[field][id].radio,
                    [value]: fieldValue
                  }
                }
              }
            }
          }
        }
      }
      case 'textinput' : {
        const { id, field } = action.location
        const { value, fieldValue } = action.payload
        return {
          ...state,
          formDataValue: {
            CL: {
              ...state.formDataValue.CL,
              [field]: {
                ...state.formDataValue.CL[field],
                [id]: {
                  ...state.formDataValue.CL[field][id],
                  textValues: {
                    ...state.formDataValue.CL[field][id].textValues,
                    [value]: fieldValue
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: '',
  isFetchingData: false,
  renderData: {},
  formDataValue: {
    CL: {
      queryLine: {
        radio: {
          query: 'Select Query',
          team: 'Team'
        }
      },
      navigation: {
        textValues: {
          currentRecord: '1'
        }
      },
      settingsLine: {
        textValues: {
          currentLegYear: '2019',
          fileId: '',
          legisId: ''
        },
        radio: {
          carryOver: ''
        }
      },
      currentLegisProgress: {
        selected: []
      },
      otherDocs: {
        0: {
          textValues: {
            urlIdDocs: '',
            urlDescription: ''
          },
          radio: {
            docsType: 'versions'
          }
        }
      },
      currentLegisSummary: {
        radio: {
          summaryView: 'f'
        }
      },
      recordInfo: {
        textValues: {
          url: '',
          version: '',
          highlight: ''
        }
      },
      clients: {
        selected: []
      },
      groupings: {
        selected: []
      },
      managementComments: {
        radio: {
          teamNumber: ''
        },
        selected: []
      },
      clientAction: {
        selected: []
      }
    }
  }
}
export default function currentLegislationReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/currentLegislationData.js